var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import * as _ from 'lodash';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import gql from 'graphql-tag';
import { CARRIERS, COMPANIES, LOCATIONS, PRODUCTS, SILOS } from '@/queries/admin';
import { verifyBolForm, fixBolDate, cleanBol, transformForCreate, addSilo, removeSilo } from '@/services/sharedForm';
var CreateBOL = /** @class */ (function (_super) {
    __extends(CreateBOL, _super);
    function CreateBOL() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bolObj = {
            date: moment().toDate(),
            weights: [{
                    silo: '',
                    net_weight: null,
                }]
        };
        _this.isSaving = false;
        _this.isEditing = false;
        _this.bolLoading = false;
        _this.showHalliburtonFields = false;
        _this.useAutoBol = ['auto'];
        _this.isGoodrich = process.env.HASURA_BASE_URL.indexOf('wright') === -1;
        _this.halliburtonSites = [
            {
                name: 'Vernal',
                id: 2013720
            },
            {
                name: 'Craig',
                id: 5882221
            }
        ];
        _this.locations = [];
        _this.companies = [];
        _this.silos = [];
        _this.products = [];
        _this.carriers = [];
        _this.availableSilos = [];
        _this.availableSandTypes = [];
        _this.splitLoad = addSilo;
        _this.removeSplitLoad = removeSilo;
        return _this;
    }
    CreateBOL.prototype.metaInfo = function () {
        return {
            title: 'Create BOL'
        };
    };
    Object.defineProperty(CreateBOL.prototype, "locationObj", {
        get: function () {
            var _this = this;
            return _.find(this.locations, function (location) { return location.name === _this.bolObj.location; });
        },
        set: function (location) {
            (location && location.name) ? this.bolObj.location = location.name : this.bolObj.location = '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateBOL.prototype, "carrierObj", {
        get: function () {
            var _this = this;
            return _.find(this.carriers, function (carrier) { return carrier.name === _this.bolObj.carrier; });
        },
        set: function (carrier) {
            (carrier && carrier.name) ? this.bolObj.carrier = carrier.name : this.bolObj.carrier = '';
        },
        enumerable: true,
        configurable: true
    });
    CreateBOL.prototype.toggleHalliburtonFields = function () {
        this.showHalliburtonFields = this.bolObj.customer === 'Halliburton';
        if (!this.showHalliburtonFields) {
            delete this.bolObj.halliburton_tms;
            delete this.bolObj.halliburton_po;
            delete this.bolObj.halliburton_location;
        }
    };
    CreateBOL.prototype.resetBolNum = function () {
        this.bolObj = Object.assign({}, this.bolObj, { bill_of_lading: null });
    };
    CreateBOL.prototype.changeOptions = function () {
        var _this = this;
        var filteredSilos = this.silos.slice();
        var filteredSandTypes = this.products.slice();
        if (this.bolObj.product && this.bolObj.product.length) {
            filteredSilos = _.filter(filteredSilos, function (silo) { return silo.product === _this.bolObj.product; });
        }
        if (this.bolObj.silo && this.bolObj.silo.length) {
            filteredSandTypes = _.filter(filteredSandTypes, function (sandType) {
                return _.some(_this.silos, function (silo) { return silo.product === sandType.name && silo.name === _this.bolObj.silo; });
            });
        }
        this.availableSandTypes = filteredSandTypes;
        this.availableSilos = filteredSilos;
    };
    CreateBOL.prototype.createBOL = function () {
        return __awaiter(this, void 0, void 0, function () {
            var saveBOL, cleanedBol, transformedBol, res, id, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isSaving) {
                            return [2 /*return*/];
                        }
                        if (!verifyBolForm(this.bolObj)) {
                            this.$toast.open({
                                duration: 5000,
                                message: 'Please check to make sure the form is filled out properly.',
                                position: 'is-top',
                                type: 'is-warning'
                            });
                            return [2 /*return*/];
                        }
                        this.isSaving = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fixBolDate(this.bolObj)];
                    case 2:
                        saveBOL = _a.sent();
                        cleanedBol = cleanBol(saveBOL);
                        transformedBol = transformForCreate(cleanedBol, saveBOL);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["mutation ($bol: bols_insert_input!) {\n          insert_bols (\n            objects: [$bol]\n          ) {\n            returning {\n              id\n            }\n          }\n        }"], ["mutation ($bol: bols_insert_input!) {\n          insert_bols (\n            objects: [$bol]\n          ) {\n            returning {\n              id\n            }\n          }\n        }"]))),
                                variables: {
                                    bol: transformedBol,
                                }
                            })];
                    case 3:
                        res = _a.sent();
                        id = res.data.insert_bols.returning[0].id;
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully created BOL.',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        this.$router.push({ name: 'Edit BOL', params: { id: id } });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error creating BOL. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        this.isSaving = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateBOL = __decorate([
        Component({
            name: 'create-bol',
            components: { Multiselect: Multiselect },
            apollo: {
                carriers: {
                    query: function () { return CARRIERS; },
                    fetchPolicy: 'no-cache'
                },
                companies: {
                    query: function () { return COMPANIES; },
                    fetchPolicy: 'no-cache'
                },
                locations: {
                    query: function () { return LOCATIONS; },
                    fetchPolicy: 'no-cache'
                },
                products: {
                    query: function () { return PRODUCTS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.availableSandTypes = data.products;
                    }
                },
                silos: {
                    query: function () { return SILOS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.availableSilos = data.silos;
                    }
                }
            }
        })
    ], CreateBOL);
    return CreateBOL;
}(Vue));
export default CreateBOL;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/CreateBOL.vue
// module id = 779
// module chunks = 1